import Logger from '@/lib/logger';
import { NEXT_PUBLIC_CONSENT_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('Consent', 'DEBUG');

if (NEXT_PUBLIC_CONSENT_LOGGING_ENABLED) {
  logger.enable();
}

export default logger;
